import React, { useState } from 'react'
import { Box, Container, Grid, Typography, } from '@mui/material';
import Create from './Createform';
import Fileupload from './Fileupload';
import { API_URL, APP_URL, ethcontractaddress, ETH_Chainid } from '../../../../Config';
import { useWeb3React } from '@web3-react/core';
import { ABI, bsccontractaddress, maticcontractaddress } from "../../../../Config/index";
import swal from 'sweetalert';
import { useCheckChain } from "../../../../Hooks/useCheckChain";
import { Matic_Chainid, Bsc_Chainid } from "../../../../Config/index";
import axios from 'axios';
import Loading from "../../../../Components/loader/loader";
import { useHistory } from "react-router-dom";
import Swal from 'sweetalert2';

const Singlenft = () => {
  const { library, account, chainId } = useWeb3React();
  const { switchChain } = useCheckChain();
  const [isloading, setisloading] = useState(false);
  const redirect = useHistory();
  const [state, setStatedata] = useState([])
  const [property, setProperty] = useState([])
  const [level, setlevel] = useState([]);
  const [hash,sethash] =useState("");
  const JWT = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJlNzVhZjZiZS0yM2RjLTRiNjQtODZhMy01ZTNkOTA4NjY4NTIiLCJlbWFpbCI6InBla29yZXkzNTlAdm9vdGluLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiRlJBMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfSx7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiI2MGRhNWRmYThmMzJjZGY2ZTNjMSIsInNjb3BlZEtleVNlY3JldCI6IjBmMzUyMjgxODk4Nzc0Y2RlN2E4NmY5OTBjMTZjMjE2MDAwOGIwOWZhYzE4ZDhmMzY4YzRkMTNjOGIyYTljZjkiLCJpYXQiOjE2Nzc2NzU2NTl9.ZC5X4sR2FXaxCPPtEG4ZcRHGkMaEeb7n8JXTJz5_wo8'
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    let NFTname = e.target.title.value;
    let description = e.target.discription.value;
    let price = e.target.price.value;
    let image = e.target.image.files;
    let currency = e.target.currency.value;
    let category = e.target.category.value;
    let collection = e.target.collection.value;
    let royalty = e.target.royalty.value;
    let selectedchainid;
    if (currency == "BNB") {
      selectedchainid = Bsc_Chainid;
    } else if (currency == "MATIC") {
      selectedchainid = Matic_Chainid;
    } else if (currency == "ETH") {
      selectedchainid = ETH_Chainid;
    }
    const tokenId = Math.floor(Math.random() * 1000000);
    let filename;
    // let url
    if (image.length > 0) {
      filename = image[0].name;
      filename = filename.replace(/^.*[\\\/]/, '')
      // url = APP_URL + '/metadata/' + tokenId;
    }

    if (library) {

      if (chainId === selectedchainid) {
        let contract_address;
        if (chainId === Bsc_Chainid) {
          contract_address = bsccontractaddress
        } else if (chainId === Matic_Chainid) {
          contract_address = maticcontractaddress
        } else if (chainId === ETH_Chainid) {
          contract_address = ethcontractaddress
        }

        if (NFTname !== "" && description !== "" && price>0 && image !== "" && royalty !== "" && collection !== "") {
          if (royalty <= 50) {
            setisloading(true);
            let response = await updatedata(NFTname, description, price, royalty, image[0], tokenId, currency, category, collection, state, property, level, contract_address)
            let res = await getMetadata(image[0],tokenId,NFTname,description ,state, property, level, );
            sethash(res.data.IpfsHash);
            if (response.data.code == 200) {
              const url ="ipfs://" +res.data.IpfsHash ;  

              const Web3 = require('web3');
              const web3 = new Web3(library.provider);
              const contract = await new web3.eth.Contract(ABI, contract_address);
              let value = web3.utils.toWei(price.toString(), "ether");
              let creationfee = await contract.methods.creationFees().call();

              let fees = "0";
              let feevalue = 0;
              if (creationfee > 0) {
                fees = '0';
                feevalue = price * creationfee / 100;
                feevalue = web3.utils.toWei(feevalue.toString(), "ether");
              }

              await contract.methods.mintNFT(url, fees, tokenId.toString(), false, value, contract_address, royalty.toString()).estimateGas({
                from: account.toString(),
                value: feevalue
              })

              await contract.methods.mintNFT(url, fees, tokenId.toString(), false, value, contract_address, royalty.toString()).send({
                from: account.toString(),
                value: feevalue
              }).then(() => {
                // swal({
                //   title: "Success",
                //   text: "Congratulations! You successfully minted NFT",
                //   icon: "success",
                //   allowOutsideClick: false,
                //   confirmButtonText: 'ok',
                //   confirmButtonColor: '#2dbe60',
                // })
                Swal.fire({ 
                  title: "Congratulations! You successfully minted NFT ", 
                  html: `<a href="https://gateway.pinata.cloud/ipfs/${hash}" target="blank">IPFS HASH</a>`,
                  icon: "success" ,
                  allowOutsideClick: false,
                  confirmButtonText: 'ok',
                  confirmButtonColor: '#2dbe60',})
                  .then(() => {
                    redirect.push('./Myitem')
                  });
                setisloading(false)
              }).catch(() => {
                deletenft(tokenId);
                setisloading(false);
              })
            } else {
              setisloading(false);
              deletenft(tokenId);
              swal({
                title: "Warning",
                text: response.data.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
              })
            }

          } else {
            setisloading(false);
            swal({
              title: "error",
              text: "Please enter the royalty less than 50!",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: 'ok',
              confirmButtonColor: '#2dbe60',
            })
              .then(() => {
              });

          }

        } else {
          setisloading(false);
          swal({
            icon: "error",
            text: 'Please fill all the required details',
            title: "error",
            allowOutsideClick: false,
            confirmButtonText: 'ok',
            confirmButtonColor: '#2dbe60',
          })
        }

      } else {
        switchChain(selectedchainid);
      }

    } else {
      swal({
        icon: "error",
        text: 'Please connect your wallet First',
        title: "error",
        allowOutsideClick: false,
        confirmButtonText: 'ok',
        confirmButtonColor: '#2dbe60',
      })
    }
  }

  const updatedata = async (NFTname, description, price, royalty, fileImg, tokenId, currency, category, collection, state, property, level, contract_address) => {
    let statename;
    let statevalue;
    let propertyname;
    let propertyvalue;
    let levelname;
    let levelvalue;

    if (state != "" || property != "" || level != "") {
      //  state values
      statename = state.map(e => e.name).join(",");
      statevalue = state.map(e => e.value).join(",");
      // property values
      propertyname = property.map(e => e.type).join(",");
      propertyvalue = property.map(e => e.propname).join(",");
      // level values
      levelname = level.map(e => e.name).join(",");
      levelvalue = level.map(e => e.value).join(",");
    }

    var data = new FormData();
    data.append("NFT_name", NFTname);
    data.append("NFT_price", price);
    data.append("NFT_royalties", royalty);
    data.append("NFT_resell", 'on');
    data.append("NFT_payment", currency);
    data.append("NFT_owner_address", account);
    data.append("NFT_discription", description);
    data.append("NFT_category", category);
    data.append("NFT_id", tokenId);
    data.append("NFT_collection", collection);
    data.append("tokenImage", fileImg);
    data.append("stat", statename);
    data.append("statvalue", statevalue);
    data.append("level", levelname);
    data.append("levelvalue", levelvalue);
    data.append("property", propertyname);
    data.append("propertyvalue", propertyvalue);
    data.append("Member_nft", '0');
    data.append("paymentcurrency", contract_address);
    data.append("NFT_chainid", chainId);
    data.append("Tokens", '0');
    data.append("TokenName", '0');

    return await axios.post(`${API_URL}/save.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const deletenft = async (NFTid) => {
    var data = new FormData();
    data.append("NFT_id", NFTid);

    return await axios.post(`${API_URL}/DeleteNft.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  const PinFiletoIPFS = async(image)=>{         
    const formData = new FormData();
    formData.append('file', image);
      try {
          return await axios.post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
              maxBodyLength: "Infinity",
              headers: {
                  'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
                  Authorization: JWT
              }
              
          });       
      } catch (error) {
          console.log(error);
      }
  }

  const getMetadata = async(image,NFTid,NFTname,Description,state, property, level)=>{
      console.log(state, property, level);
      const attribute =[];
      if(state!=""){
        for(let i=0;i<state.length;i++){
          let stateattribute={
                  "trait_type": state[i].name,
                  "value" :state[i].value
                }
              attribute.push(stateattribute);
        }
      }
     
      if(level!=""){
        for(let i=0;i<level.length;i++){
          let levelattribute={
                  "trait_type": level[i].name,
                  "value" :level[i].value
                }
              attribute.push(levelattribute);
        }
      }
    
    if(property!=""){
      for(let i=0;i<property.length;i++){
        let propertyattribute={
                "trait_type": property[i].name,
                "value" :property[i].value
              }
            attribute.push(propertyattribute);
      }
    }
    
    console.log(attribute,"attribute");

      const imageurl = await PinFiletoIPFS(image);
      console.log(imageurl);
      const body =JSON.stringify({
          NFT_id:NFTid,
          name: NFTname,
          description: Description,
          image:"ipfs://"+imageurl.data.IpfsHash,
          attributes:attribute
      })
      return await PinJsontoIPFS(body);
      // console.log("metadata",metadata);
  }

  const PinJsontoIPFS=async(data)=>{
        try {
          return await axios.post("https://api.pinata.cloud/pinning/pinJSONToIPFS", data,{
                maxBodyLength: "Infinity",
                headers: {
                    'Content-Type': `application/json`,
                    Authorization: JWT
                },
                
            }); 
          
        } catch (error) {
            console.log(error);
        }
  }

  return (
    <div>
      <Box className='single_start'>
        <Container maxWidth='xl'>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <Box className=''>
                <Typography variant='h2'>
                  Create NFT
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className='create_nft' component='form' method="post" enctype='multipart/form-data' onSubmit={handleSubmit}>
        <Container maxWidth='md'>
          <Grid container spacing={2} className='Dynamic_box'>
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <Fileupload />
              <Create setStatedata={setStatedata} setProperty={setProperty} setlevel={setlevel} state={state && state} property={property && property} level={level && level} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      {isloading && (
        <Loading props={'Transaction in process, Please wait do not refresh the page...'} />
      )}

    </div>
  )
}

export default Singlenft;